var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useMemo, useState } from "react";
import { useGetCallCountsByPeriodsMutation, useGetKpiForCasesMutation, useGetRelationshipWOpportunitiesMutation, } from "@/store/api";
import { ETCRM_URL } from "@/utils/const";
import ChartTypeSelector from "./chartTypeSelector";
import { calculateRanges, get_current_language, } from "@/components/forms/components/utils";
import { useParams } from "react-router-dom";
import { useChartsData } from "@/utils/useChartData";
import { useTranslation } from "react-i18next";
var ChartsList = function (_a) {
    var addNewDashletPreference = _a.addNewDashletPreference;
    var _b = useState(true), isOpen = _b[0], setIsOpen = _b[1];
    var _c = useChartsData(), opportunitiesByLeadSourceDashlets = _c.opportunitiesByLeadSourceDashlets, opportunitiesByLeadSourceByOutcomeDashlets = _c.opportunitiesByLeadSourceByOutcomeDashlets, pipelineBySalesDashlets = _c.pipelineBySalesDashlets, outcomeByMonthDashlets = _c.outcomeByMonthDashlets, myPipelineBySalesStageDashlet = _c.myPipelineBySalesStageDashlet;
    var generateChart = function (id, dashletData, type, widget, fallbackTitle) {
        var _a, _b, _c, _d, _e, _f, _g;
        if (widget === void 0) { widget = "dashlet/chart"; }
        if (fallbackTitle === void 0) { fallbackTitle = ""; }
        return ({
            id: id,
            title: ((_c = (_b = (_a = dashletData === null || dashletData === void 0 ? void 0 : dashletData.data) === null || _a === void 0 ? void 0 : _a.dashlets) === null || _b === void 0 ? void 0 : _b[get_current_language() === "en_us" ? "lang_en" : "lang_fr"]) === null || _c === void 0 ? void 0 : _c.LBL_TITLE) || fallbackTitle,
            urlImage: (_f = (_e = (_d = dashletData === null || dashletData === void 0 ? void 0 : dashletData.data) === null || _d === void 0 ? void 0 : _d.dashlets) === null || _e === void 0 ? void 0 : _e.meta) === null || _f === void 0 ? void 0 : _f.icon,
            chartData: ((_g = dashletData === null || dashletData === void 0 ? void 0 : dashletData.data) === null || _g === void 0 ? void 0 : _g.dashlets) || [],
            type: type,
            widget: widget,
        });
    };
    var createKpiChart = function (title, chartData, type, widget, kpiType, description) { return ({
        id: uuidv4(),
        title: title,
        urlImage: "icon_Charts_Horizontal_32.gif",
        chartData: chartData,
        type: type,
        widget: widget,
        kpiType: kpiType,
        description: description,
    }); };
    var _d = useParams(), currentModule = _d.module, action = _d.action, record = _d.record;
    var _e = useState({
        ca: [],
        efficiency: [],
        pipeline: [],
        salesCycle: [],
        callsCount: [],
        firstContactResolved: [],
        loyaltyrate: [],
        averageResolutionTime: [],
        averageResponseTime: [],
        openClosedTicket: [],
        costPerResolution: [],
        escalationRate: [],
        agentOccupationRate: [],
        averageCustomerEffort: [],
    }), chartData = _e[0], setChartData = _e[1];
    var _f = useGetRelationshipWOpportunitiesMutation(), getRelationshipWOpportunities = _f[0], _g = _f[1], data = _g.data, error = _g.error;
    var _h = useGetCallCountsByPeriodsMutation(), getCallCountsByPeriods = _h[0], _j = _h[1];
    var uuidv4 = require("uuid").v4;
    var _k = useGetKpiForCasesMutation(), getKpiForCases = _k[0], _l = _k[1];
    useEffect(function () {
        var fetchData = function () { return __awaiter(void 0, void 0, void 0, function () {
            var dateRanges, _a, resultCA, resultEff, resultPipeline, resultSalesCycle, resultCallsCount, resultFirstContactResolved, resultAverageResolutionTime, resultAverageResponseTime, resultOpenClosedTicket, resultCostPerResolution, resultEscalationRate, resultAgentOccupationRate, resultAverageCustomerEffort, err_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        dateRanges = calculateRanges("semaine", "La semaine dernière");
                        return [4 /*yield*/, Promise.all([
                                getRelationshipWOpportunities({
                                    module: currentModule || "",
                                    body: { cumulatif: "non", periods: dateRanges },
                                }).unwrap(),
                                getRelationshipWOpportunities({
                                    module: currentModule || "",
                                    body: {
                                        cumulatif: "non",
                                        periods: dateRanges,
                                        kpiType: "efficiency",
                                    },
                                }).unwrap(),
                                getRelationshipWOpportunities({
                                    module: currentModule || "",
                                    body: {
                                        cumulatif: "non",
                                        periods: dateRanges,
                                        kpiType: "pipeline",
                                    },
                                }).unwrap(),
                                getRelationshipWOpportunities({
                                    module: "",
                                    body: {
                                        cumulatif: "non",
                                        periods: dateRanges,
                                        kpiType: "salesCycle",
                                    },
                                }).unwrap(),
                                getCallCountsByPeriods({
                                    module: "",
                                    body: {
                                        periods: dateRanges,
                                    },
                                }).unwrap(),
                                getKpiForCases({
                                    module: "",
                                    body: {
                                        periods: dateRanges,
                                    },
                                }).unwrap(),
                                getKpiForCases({
                                    module: "",
                                    body: {
                                        periods: dateRanges,
                                        kpiType: "averageResolutionTime",
                                        unit: "semestre",
                                    },
                                }).unwrap(),
                                getKpiForCases({
                                    module: "",
                                    body: {
                                        periods: dateRanges,
                                        kpiType: "averageResponseTime",
                                        unit: "semestre",
                                    },
                                }).unwrap(),
                                getKpiForCases({
                                    module: "",
                                    body: {
                                        periods: dateRanges,
                                        kpiType: "openedClosedTickets",
                                    },
                                }).unwrap(),
                                getKpiForCases({
                                    module: "",
                                    body: {
                                        periods: dateRanges,
                                        kpiType: "costPerResolution",
                                    },
                                }).unwrap(),
                                getKpiForCases({
                                    module: "",
                                    body: {
                                        periods: dateRanges,
                                        kpiType: "escalationRate",
                                    },
                                }).unwrap(),
                                getKpiForCases({
                                    module: "",
                                    body: {
                                        periods: dateRanges,
                                        kpiType: "agentOccupationRate",
                                    },
                                }).unwrap(),
                                getKpiForCases({
                                    module: "",
                                    body: {
                                        periods: dateRanges,
                                        kpiType: "averageCustomerEffort",
                                    },
                                }).unwrap(),
                            ])];
                    case 1:
                        _a = _b.sent(), resultCA = _a[0], resultEff = _a[1], resultPipeline = _a[2], resultSalesCycle = _a[3], resultCallsCount = _a[4], resultFirstContactResolved = _a[5], resultAverageResolutionTime = _a[6], resultAverageResponseTime = _a[7], resultOpenClosedTicket = _a[8], resultCostPerResolution = _a[9], resultEscalationRate = _a[10], resultAgentOccupationRate = _a[11], resultAverageCustomerEffort = _a[12];
                        setChartData({
                            ca: (resultCA === null || resultCA === void 0 ? void 0 : resultCA.data) || [],
                            efficiency: (resultEff === null || resultEff === void 0 ? void 0 : resultEff.data) || [],
                            pipeline: (resultPipeline === null || resultPipeline === void 0 ? void 0 : resultPipeline.data) || [],
                            salesCycle: (resultSalesCycle === null || resultSalesCycle === void 0 ? void 0 : resultSalesCycle.data) || [],
                            callsCount: (resultCallsCount === null || resultCallsCount === void 0 ? void 0 : resultCallsCount.data) || [],
                            firstContactResolved: (resultFirstContactResolved === null || resultFirstContactResolved === void 0 ? void 0 : resultFirstContactResolved.data) || [],
                            loyaltyrate: (resultPipeline === null || resultPipeline === void 0 ? void 0 : resultPipeline.data) || [],
                            averageResolutionTime: (resultAverageResolutionTime === null || resultAverageResolutionTime === void 0 ? void 0 : resultAverageResolutionTime.data) || [],
                            averageResponseTime: (resultAverageResponseTime === null || resultAverageResponseTime === void 0 ? void 0 : resultAverageResponseTime.data) || [],
                            openClosedTicket: (resultOpenClosedTicket === null || resultOpenClosedTicket === void 0 ? void 0 : resultOpenClosedTicket.data) || [],
                            costPerResolution: (resultCostPerResolution === null || resultCostPerResolution === void 0 ? void 0 : resultCostPerResolution.data) || [],
                            escalationRate: (resultEscalationRate === null || resultEscalationRate === void 0 ? void 0 : resultEscalationRate.data) || [],
                            agentOccupationRate: (resultAgentOccupationRate === null || resultAgentOccupationRate === void 0 ? void 0 : resultAgentOccupationRate.data) || [],
                            averageCustomerEffort: (resultAverageCustomerEffort === null || resultAverageCustomerEffort === void 0 ? void 0 : resultAverageCustomerEffort.data) || [],
                        });
                        return [3 /*break*/, 3];
                    case 2:
                        err_1 = _b.sent();
                        console.error("Failed to fetch relationship:", err_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        fetchData();
    }, [currentModule]);
    var t = useTranslation(["common", "Home"]).t;
    var charts = useMemo(function () { return [
        generateChart(uuidv4(), opportunitiesByLeadSourceByOutcomeDashlets === null || opportunitiesByLeadSourceByOutcomeDashlets === void 0 ? void 0 : opportunitiesByLeadSourceByOutcomeDashlets.currentData, "horizontalBar"),
        generateChart(uuidv4(), opportunitiesByLeadSourceDashlets === null || opportunitiesByLeadSourceDashlets === void 0 ? void 0 : opportunitiesByLeadSourceDashlets.currentData, "pie"),
        generateChart(uuidv4(), myPipelineBySalesStageDashlet === null || myPipelineBySalesStageDashlet === void 0 ? void 0 : myPipelineBySalesStageDashlet.currentData, "horizontalBar"),
        generateChart(uuidv4(), outcomeByMonthDashlets === null || outcomeByMonthDashlets === void 0 ? void 0 : outcomeByMonthDashlets.currentData, "bar"),
        generateChart(uuidv4(), pipelineBySalesDashlets === null || pipelineBySalesDashlets === void 0 ? void 0 : pipelineBySalesDashlets.currentData, "horizontalBar"),
        createKpiChart(t("app.LBL_TOTAL_REVENUE", { ns: "common" }), chartData.ca, "horizontalBar", "KPIAffaires", "CA"),
        createKpiChart(t("app.LBL_OPPORTUNITY_CONVERSION_RATE", { ns: "common" }), chartData.efficiency, "horizontalBar", "KPIAffaires", "efficiency"),
        createKpiChart(t("app.LBL_SALES_PIPELINE", { ns: "common" }), chartData.pipeline, "funnelGraph", "KPIAffaires", "pipeline"),
        createKpiChart(t("app.LBL_QUALIFIED_LEADS", { ns: "common" }), chartData.pipeline, "horizontalBar", "KPILeads", "leadscount"),
        createKpiChart(t("app.LBL_CUSTOMER_RETENTION_RATE", { ns: "common" }), chartData.loyaltyrate, "horizontalBar", "KPIContracts", "loyaltyrate"),
        createKpiChart(t("app.LBL_AVERAGE_SALES_CYCLE", { ns: "common" }), chartData.salesCycle, "horizontalBar", "KPIAffaires", "salesCycle"),
        createKpiChart(t("app.LBL_PROSPECTING_CALLS", { ns: "common" }), chartData.callsCount, "horizontalBar", "KPICalls", "callscount"),
        createKpiChart(t("app.LBL_FIRST_CONTACT_RESOLUTION", { ns: "common" }), chartData.firstContactResolved, "horizontalBar", "KPICases", "resolvedContact"),
        createKpiChart(t("app.LBL_AVG_TICKET_RESOLUTION_TIME", { ns: "common" }), chartData.averageResolutionTime, "horizontalBar", "KPICases", "averageResolutionTime"),
        createKpiChart(t("app.LBL_FIRST_RESPONSE_TIME", { ns: "common" }), chartData.averageResolutionTime, "horizontalBar", "KPICases", "averageResponseTime"),
        createKpiChart(t("app.LBL_TICKETS_HANDLED", { ns: "common" }), chartData.openClosedTicket, "horizontalBar", "KPICases", "openedClosedTickets"),
        createKpiChart(t("app.LBL_AVG_TICKET_COST", { ns: "common" }), chartData.costPerResolution, "horizontalBar", "KPICases", "costPerResolution"),
        createKpiChart(t("app.LBL_ESCALATION_RATE", { ns: "common" }), chartData.escalationRate, "horizontalBar", "KPICases", "escalationRate"),
        createKpiChart(t("app.LBL_AGENT_OCCUPANCY_RATE", { ns: "common" }), chartData.agentOccupationRate, "horizontalBar", "KPICases", "agentOccupationRate"),
        createKpiChart(t("app.LBL_AVERAGE_CUSTOMER_EFFORT", { ns: "common" }), chartData.averageCustomerEffort, "horizontalBar", "KPICases", "averageCustomerEffort"),
    ]; }, [
        opportunitiesByLeadSourceByOutcomeDashlets,
        opportunitiesByLeadSourceDashlets,
        myPipelineBySalesStageDashlet,
        outcomeByMonthDashlets,
        pipelineBySalesDashlets,
        chartData,
    ]);
    var _m = useState({}), chartTypes = _m[0], setChartTypes = _m[1];
    var optionsGraph = [
        { value: "texte", label: t("app.LBL_TEXT_CHART", { ns: "common" }) },
        {
            value: "horizontalBar",
            label: t("app.LBL_HORIZONTALBAR_CHART", { ns: "common" }),
        },
        { value: "bar", label: t("app.LBL_BAR_CHART", { ns: "common" }) },
        { value: "line", label: t("app.LBL_LINE_CHART", { ns: "common" }) },
    ];
    var optionsPipeline = [
        { value: "texte", label: "Texte" },
        { value: "funnelGraph", label: "Funnel" },
    ];
    var optionsTxt = [{ value: "texte", label: "Texte" }];
    var handleChartTypeChange = function (chart, value) {
        setChartTypes(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[chart.id] = value, _a)));
        });
        addNewDashletPreference("Home", chart.widget, {
            chartData: chart.chartData,
            type: value,
            title: chart.title,
            value: chart.value,
            kpiType: chart.kpiType,
        });
        setChartTypes(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[chart.id] = "", _a)));
        });
    };
    var getOptionsByKpiType = function (kpiType) {
        switch (kpiType) {
            case "CA":
            case "callscount":
            case "efficiency":
            case "resolvedContact":
            case "averageResolutionTime":
            case "averageResponseTime":
            case "openedClosedTickets":
            case "costPerResolution":
            case "escalationRate":
            case "salesCycle":
            case "agentOccupationRate":
            case "averageCustomerEffort":
                return optionsGraph;
            case "pipeline":
                return optionsPipeline;
            case "leadscount":
                return optionsTxt;
            default:
                return undefined;
        }
    };
    return (_jsxs("div", __assign({ className: "p-4" }, { children: [_jsxs("div", __assign({ className: "flex items-center cursor-pointer", onClick: function () { return setIsOpen(!isOpen); } }, { children: [_jsx(FontAwesomeIcon, { icon: faChevronDown, className: "transition-transform duration-200 ".concat(isOpen ? "rotate-180" : "rotate-0") }), _jsx("h2", __assign({ className: "ml-2 font-bold uppercase text-sm" }, { children: t("LBL_BASIC_CHARTS", { ns: "Home" }) }))] })), isOpen && (_jsx("ul", __assign({ className: "mt-2 relative" }, { children: charts.map(function (chart) { return (_jsxs("li", __assign({ className: "flex text-[--colors-label] items-center p-2 justify-between hover:bg-[var(--colors-body-bg)] rounded-md cursor-pointer" }, { children: [_jsxs("div", __assign({ className: "flex  items-start" }, { children: [_jsx("img", { src: "".concat(ETCRM_URL, "/themes/etcrm2/images/").concat(chart.urlImage), alt: chart.title }), _jsx("span", __assign({ className: "text-sm px-1", onClick: function () {
                                        return addNewDashletPreference("Home", chart.widget, {
                                            chartData: chart.chartData,
                                            type: chart.type,
                                            title: chart.title,
                                            value: chart.value,
                                        });
                                    } }, { children: chart.title }))] })), _jsx("section", __assign({ className: "flex  items-end" }, { children: _jsx(ChartTypeSelector, { value: chartTypes[chart.id] || "", onChange: function (value) { return handleChartTypeChange(chart, value); }, options: getOptionsByKpiType(chart.kpiType) }) }))] }), chart.id)); }) })))] })));
};
export default ChartsList;
